import { deleteUserArea } from "api";
import { RetrieveMasterPlanDetails } from "Redux/RetrieveMasterPlan/action";
import { Error } from "Responses/Response";
import { getCookie } from "utils/StorageVariables";
import { ActionTypes } from "./types";

/**
 * Deletes a user area (one row on "Select Your Areas & Categories").
 *
 * `onDeleted` runs only after the server has removed the row, and the
 * masterplan is reloaded only after it finishes. Running the re-prioritize
 * request in parallel with the DELETE let the backend recalculate goal weights
 * with the deleted goal still present, and let the reload race the reorder
 * (ARO-7129).
 */
export const DeleteUserArea = (id, onDeleted) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await deleteUserArea(id);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 204) {
      if (onDeleted) await onDeleted();
      let MasterPlanId = getCookie("MasterPlanId");
      if (MasterPlanId)
        return dispatch(RetrieveMasterPlanDetails(MasterPlanId));
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
